import React, { useCallback } from 'react';
import { Flex } from 'web-ui-kit/containers';
import styled from 'styled-components';
import { CompressedImage } from 'web-services/Imgix';

import StrikethroughLine from './StrikethroughLine';
import {
  IMAGE_CELL_SIZE,
  VariantSelectionState,
  getCSSForState
} from './utils';

/**
 * Variant for color, uses the image for the product
 * centered and scaled to fill the section
 */
export default function ColorVariant ({
  attributeType,
  attributeValue,
  src,
  state,
  updateSelectedForAttribute
}) {
  const onClick = useCallback(() => {
    state !== VariantSelectionState.DISABLED && updateSelectedForAttribute({ attributeType, attributeValue });
  }, [attributeType, attributeValue, state, updateSelectedForAttribute]);

  return (
    <Frame
      data-testid={`AttributeComponent:${attributeType}:${attributeValue}`}
      onClick={onClick}
      stateCSS={getCSSForState(state)}
    >
      <InnerFrame>
        <Image
          data-testid={`AttributeImage:${attributeType}:${attributeValue}`}
          src={src}
          width={128}
          height={128}
          bucketName='modsy'
          alt={attributeValue}
        />
        <StrikethroughLine state={state} type={attributeType} />
      </InnerFrame>
    </Frame>
  );
}

const Frame = styled(Flex)`
  position: relative;
  justify-content: center;
  align-items: center;
  width: ${IMAGE_CELL_SIZE}px;
  height: ${IMAGE_CELL_SIZE}px;
  overflow: hidden;
  cursor: pointer;
  ${props => props.stateCSS}
`;
Frame.displayName = 'Frame';

const InnerFrame = styled.div`
  position: relative;
  width: calc(100% - 4px);
  height: calc(100% - 4px);
  overflow: hidden;
`;

const Image = styled(CompressedImage)`
  width: 100%;
  height: 100%;
  transform: scale(2);
  object-fit: cover;
  box-sizing: border-box;
  overflow: hidden;
  cursor: pointer;
`;
Image.displayName = 'Image';
